import { useState } from "react";
import { ChevronDown } from "lucide-react";

const ProductDetails = ({ product }) => {
  const [openSection, setOpenSection] = useState(null);
  const details = Array.isArray(product.details) && product.details.length > 0
    ? product.details
    : product.description
    ? [{ title: 'Përshkrimi', description: product.description }]
    : [];

  const toggleSection = (index) => {
    if (openSection === index) {
      setOpenSection(null);
    } else {
      setOpenSection(index);
    }
  };

  return (
    <div className="border-t border-gray-200">
      <div className="mt-4">
        <h3 className="font-semibold">Product Details</h3>
        {details.length === 0 ? (
          <p className="text-sm text-gray-500 mt-2">Nuk ka informacione shtesë për këtë produkt.</p>
        ) : (
          details.map((detail, index) => (
            <div key={index} className="border-b border-gray-200">
              <button
                className="flex justify-between items-center w-full py-4"
                onClick={() => toggleSection(index)}
              >
                <span>{detail.title}</span>
                <ChevronDown
                  className={`h-5 w-5 transform transition-transform ${
                    openSection === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              
              {openSection === index && (
                <div className="pb-4">
                  <p>{detail.description || 'Nuk ka përshkrim.'}</p>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ProductDetails;